module.exports = __webpack_public_path__ + "static/media/childrensDay-land-page.75a66eb4.png";